import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Fordonstillgänglighet ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { square: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "text-h6 q-py-xs" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_table, {
        flat: "",
        rows: _ctx.data,
        columns: _ctx.columns,
        "hide-bottom": "",
        separator: "cell",
        "rows-per-page-options": [0],
        dense: ""
      }, {
        header: _withCtx((props) => [
          _createVNode(_component_q_tr, {
            props: props,
            style: { textAlign: 'left' },
            class: "bg-grey-3 text-body1"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                return (_openBlock(), _createBlock(_component_q_th, {
                  key: col.name,
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(col.label), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        body: _withCtx((props) => [
          _createVNode(_component_q_tr, {
            props: props,
            class: _normalizeClass(_ctx.$style.row)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_td, {
                key: "text",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.row.text), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_td, {
                key: "count",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.row.count), 1)
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 2
          }, 1032, ["props", "class"])
        ]),
        _: 1
      }, 8, ["rows", "columns"])
    ]),
    _: 1
  }))
}